import { render } from "./AccordionElement.vue?vue&type=template&id=4b2503ef&scoped=true&ts=true&lang=pug"
import script from "./AccordionElement.vue?vue&type=script&lang=ts"
export * from "./AccordionElement.vue?vue&type=script&lang=ts"

import "./AccordionElement.vue?vue&type=style&index=0&id=4b2503ef&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2503ef"]])

export default __exports__